/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template "model.velocity"
 */

/**
 * THIS Template MUST remain FRAMEWORK INDEPENDENT!! It is used for Angular, Ionic, Node-Express... any JavaScript framework
 */

/* tslint:disable */


export class RejectedEvolution {
    dossierCode?: string; // ecf001
    dossierId?: number; // ecf001
    evolutionDescriptionCode?: string; // ecf001
    depositionDate?: string; // ecf001
    rejectionDate?: string; // ecf001
    rejectionReason?: string; // ecf001
    courtOfJustice?: string; // ecf001
    documentUrl?: string; // ecf001


    // <editor-fold desc="From and To Json Methods" defaultstate="collapsed">
/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template &quot;model-json.velocity&quot;
 */

    /** ---- Generated part from .\ang-man\src\modules\generator\writers\common\templates\model-json.velocity */

    public static mergeJSON(instance: any, data: any): RejectedEvolution {
        if (!data) { return instance; }
        if (data.dossierCode != null) {instance.dossierCode = data.dossierCode; }
        if (data.dossierId != null) {instance.dossierId = data.dossierId; }
        if (data.evolutionDescriptionCode != null) {instance.evolutionDescriptionCode = data.evolutionDescriptionCode; }
        if (data.depositionDate != null) {instance.depositionDate = data.depositionDate; }
        if (data.rejectionDate != null) {instance.rejectionDate = data.rejectionDate; }
        if (data.rejectionReason != null) {instance.rejectionReason = data.rejectionReason; }
        if (data.courtOfJustice != null) {instance.courtOfJustice = data.courtOfJustice; }
        if (data.documentUrl != null) {instance.documentUrl = data.documentUrl; }
        return instance; // ir
    }

    public fromJSON(data: any): this { // cbn001
        return RejectedEvolution.mergeJSON(this, data) as any;
    }

    public static mergeJSONFromObject(target: any, object: RejectedEvolution) {
        // TODO: mapping
        return object;
    }

    // toJSON ensures that only class-defined fields are exported.
    public toJSON() {
        return RejectedEvolution.mergeJSONFromObject({}, this);
    }

    // Compares this AppInfo instance with another AppInfo instance, recursively.
    // Transient fields are not considered.
    public equals(other: RejectedEvolution): boolean {
        return JSON.stringify(this.toJSON()) === JSON.stringify(other.toJSON());
    }

    /** ---- */


/** end of template &quot;model-json.velocity&quot; */

    // </editor-fold>

}


/** end of template "model.velocity" */
